export default __webpack_public_path__ + "static/media/kitchen3-afterA-1024w.1fea5516.png";